import Pdf from "imgtopdf";
import moment from 'moment';
import html2canvas from "html2canvas";

const { imgToPdf } = Pdf;



export default function imgSave(id, multiple = 1.5, sort, date = moment().format('YYYY-MM')) {
    return new Promise((res, rej) => {
        // const opts = {
        //     logging: false, //日志开关
        //     removeContainer: false,
        //     useCORS: false,
        //     allowTaint: true, //是否允许画布收到污染
        // };
        // html2canvas(document.getElementById(id), opts).then(x => {
        //     console.log(x.toDataURL('image/png', 0.1));
        // })
        // return 
        imgToPdf(id, sort == '14.00' ? 0.9 : multiple).then(img => {
            console.log(img);
            fetch('/getPdf_bp?' + `sort=${sort}&year=${moment(date).format('YYYY')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
                let dataFrom = new FormData();
                dataFrom.append('img', img.img);
                dataFrom.append('sort', sort);
                dataFrom.append('height', img.canvas.height);
                dataFrom.append('width', img.canvas.width);
                dataFrom.append('year', moment(date).format('YYYY'));
                dataFrom.append('add_time', moment().format('YYYY-MM-DD HH:mm:ss'));

                if (x.data && x.data.length > 0) {
                    dataFrom.append('id', x.data[0].id);
                }
                let headres = {
                    method: 'post',
                    credentials: 'include',
                    headers: {},
                    body: dataFrom
                }
                fetch('/addPdf_bp', headres).then(x => x.json()).then(data => {
                    res(data)
                }).catch(err => {
                    rej(err)
                })
            }).catch(err => {
                rej(err)
            })
        }).catch(err => {
            rej(err)
        })
    })

}

function getBlobBydataURI(dataURI, type) {
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: type });
}  


// WEBPACK FOOTER //
// ./src/bp-views/table/saveImg.js